import React, { useState, useRef, useEffect } from 'react';
import classNames from 'classnames';
import { SearchStrongIcon } from 'src/monet/icons';
import debounce from 'lodash/debounce';
import { Nullable } from 'src/types/nullable.type';

type Props = {
  onSearch: (searchText: string) => void;
};

export const MediaSearchInput = ({ onSearch }: Props) => {
  const [isInputFocused, setIsInputFocused] = useState(true);
  const searchInputRef = useRef<Nullable<HTMLInputElement>>(null);

  const onSearchInputChanged = debounce((value) => onSearch(value?.trim()), 500);

  // Stop the invocation of the debounced function after unmounting
  useEffect(() => {
    return () => {
      onSearchInputChanged.cancel();
    };
  }, [onSearchInputChanged]);

  return (
    <div className='relative flex'>
      <div
        className={classNames('absolute left-2 top-2.5 transition-colors', {
          'text-neue-journey-fg': isInputFocused,
          'text-neue-journey-fg-50': !isInputFocused,
        })}
      >
        <SearchStrongIcon className='w-5 h-5' />
      </div>
      <input
        type='text'
        ref={searchInputRef}
        autoFocus
        onFocus={() => {
          setIsInputFocused(true);
        }}
        onBlur={() => {
          setIsInputFocused(false);
        }}
        onChange={(event) => {
          onSearchInputChanged(event.target.value);
        }}
        className='neue-journey-text-input w-full !pl-9'
        placeholder={'Search'}
      />
    </div>
  );
};
